<template>
  <form @submit.prevent="save">
    <v-card>
      <v-toolbar flat color="primary">
        <v-toolbar-title>{{ team.name }}</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-card-title primary-title>
        <v-list-item two-line>
          <v-list-item-avatar>
            <v-img :src="team.owner.profile_photo_url" aspect-ratio="1" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              Besitzer: {{ team.owner.name }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ team.owner.email }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-title>
      <v-card-text v-if="permissions.canUpdateTeam">
        <v-text-field
          v-model="form.name"
          label="Team Name"
          required
          class="form-control"
          type="name"
          name="name"

          :class="{ 'is-invalid': form.errors.name }"
          :error="form.errors.name"
          :error-messages="form.errors.name"
        />
      </v-card-text>
      <v-card-actions v-if="permissions.canUpdateTeam">
        <v-spacer />
        <v-btn
          color="primary"
          type="submit"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
export default {
   props: {
      team: {
         type: Object,
         required: true
      },
      permissions: {
         type: Object,
         required: true
      }
   },
   data () {
      return {
         form: this.$inertia.form({
            name: null,
         })
      }
   },
   created () {
      this.form.name = this.team.name
   },
   methods: {
      save () {
         this.form.put(this.route('teams.update', this.team), {
            preserveScroll: true
         })
      },
   },
}
</script>

<style>
</style>
